exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-02dfd4c2] [class^=el-icon-]{background-color:#fff!important;padding:8px;margin-right:5rpx;border-radius:12px;color:#0f1741}.el-button[data-v-02dfd4c2]{color:#0f1741;padding:10px;border:none;border-radius:18px;margin-left:8px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-02dfd4c2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Vbutton/index.vue
// module id = akvn
// module chunks = 5